import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "../../data";
import { EASE } from "../../lib/anim";

export const Founder = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

  return (
    <section id="founder" ref={ref} className="relative bg-[#060607] py-28 sm:py-36" data-testid="founder-section">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12">
        <div className="flex items-center gap-4 mb-16">
          <span className="font-mono-x text-[11px] tracking-[0.3em] text-white/30">04</span>
          <span className="h-px w-10 bg-white/15" />
          <span className="eyebrow">Il Fondatore</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* portrait */}
          <motion.div
            initial={{ opacity: 0, scale: 1.05 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.3, ease: EASE }}
            className="lg:col-span-5 relative"
          >
            <div className="relative h-[520px] lg:h-[640px] overflow-hidden border border-white/10">
              <motion.img
                style={{ y: imgY }}
                src={IMAGES.founder}
                alt="Manuel Brunetti — MGB Aviation"
                title="MGB Aviation"
                draggable="false"
                className="absolute inset-0 h-[120%] w-full object-cover object-top grayscale contrast-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#060607] via-transparent to-[#060607]/30" />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_35%,transparent_30%,rgba(6,6,7,0.65)_100%)]" />
              <div className="absolute bottom-6 left-6">
                <p className="font-display text-2xl text-white">Manuel Brunetti</p>
              </div>
            </div>
          </motion.div>

          {/* text */}
          <div className="lg:col-span-7 lg:pl-8">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: EASE }}
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-white leading-[0.98]"
            >
              Costruire con metodo, <br /> crescere con visione.
            </motion.h2>

            <motion.div
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: EASE, delay: 0.15 }}
              className="mt-10 space-y-6 max-w-xl text-lg text-white/55 leading-relaxed"
            >
              <p>
                MGB Aviation nasce dalla passione di <span className="text-white">Manuel</span> per
                il mondo del volo e dalla volontà di trasformarne i valori in progetti concreti.
              </p>
              <p>
                Pilota e imprenditore, sviluppa una collezione di brand accomunati da una stessa
                filosofia: costruire con metodo, innovare con equilibrio e crescere con una visione
                di lungo periodo.
              </p>
              <p>
                Ogni iniziativa nasce con l'obiettivo di creare valore reale, mantenendo l'aviazione
                come elemento distintivo e fonte di ispirazione.
              </p>
            </motion.div>

            <div className="mt-12 flex gap-12 border-t border-white/10 pt-8">
              {[
                ["04", "Brand"],
                ["01", "Filosofia"],
                ["∞", "Orizzonti"],
              ].map(([n, l]) => (
                <div key={l}>
                  <p className="font-display text-3xl text-white">{n}</p>
                  <p className="eyebrow mt-2">{l}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
